import {
  toValue, 
  watch,
  //type Ref,
  //type WatchStopHandle
} from "vue";
import { type RefOrGetter } from "./ref-utility-types.js";
//import { isUndefined, isNull, isString } from "@mcwd/typescript-type-guards";
// export class ReactiveLogger {
//   #watchStopHandles = new Map<string, WatchStopHandle>();
//   #getValueString(value: unknown): string {
//     if (isUndefined(value)) 
//       return "undefined";
//     else if (isNull(value))
//       return "null";
//     else if (isString(value))
//       return `"${value}"`;
//     else return JSON.stringify(value, null, 4);
//   }

//   #log<T = unknown>(value: RefOrGetter<T>, label: string, messagePrefix: string, logLevel: string, logFn: (msg: string) => void) {
//     this.#watchStopHandles.set(logLevel + "_" + label, watch(
//       () => toValue(value),
//       (newVal, prevVal) => {
//         logFn(
//           `${messagePrefix}Changing "${label}" from ${this.#getValueString(
//             prevVal
//           )} to ${this.#getValueString(newVal)}`
//         );
//       }
//     ));
//   }
//   info<T = unknown>(value: RefOrGetter<T>, label: string, messagePrefix = "") {
//     this.#log(value, label, messagePrefix, "info", console.info);
//   }

//   removeLogger(logLevel: string, label: string){
//     const key = logLevel + "_" + label;
//     if (this.#watchStopHandles.has(key) === false ){
//       throw new Error("Label does not exist for log level");
//     }
//     else {
//       this.#watchStopHandles.delete(key);
//     }
//   }
// }

// export function useReactiveLogger() {
  
// }

export function logReactiveChanges(
  value: RefOrGetter<unknown>,
  refName: string,
  messagePrefix = ""
) {
  watch(
    () => toValue(value),
    (newVal, prevVal) => {
      console.log(
        `${messagePrefix}Changing "${refName}" from "${(prevVal ?? "").toString()}" to "${(newVal ?? "").toString()}".`
      );
    }
  );
}
